import api from './axios';

export const getCustomTeams = () => api.get('/config/teams').then(r => r.data.custom || []);
export const saveCustomTeams = (teams) => api.put('/config/teams', { teams });

export const getCustomRoles = () => api.get('/config/roles').then(r => r.data.custom || []);
export const saveCustomRoles = (roles) => api.put('/config/roles', { roles });

export const getEnabledDepartmentsConfig = () =>
  api.get('/config/departments').then((r) => r.data);

export const saveEnabledDepartmentsConfig = (payload) => {
  const body = Array.isArray(payload) ? { enabled: payload } : payload;
  return api.put("/config/departments", body).then((r) => r.data);
};
